import { observer } from "mobx-react"
import { useStore } from "@features/common"
import PartySvg from "@assets/media/safer-dating/party.svg"
import { ARTICLE_PREVIEW_CLIPPATH_ID } from "@features/journal"

import { SaferDatingButton } from "../atoms"

type BottomBannerSectionProps = {
  title: string
  description: string
  buttonText: string
  buttonHref: string
}

export const BottomBannerSection = observer(function BottomBannerSection({
  title,
  description,
  buttonText,
  buttonHref,
}: BottomBannerSectionProps) {
  const { ResponsiveModel } = useStore()

  return (
    <section className="pb-0 py-0 pt-[120px] overflow-hidden tablet-m:mt-0 tablet-m:flex tablet-m:justify-center tablet-m:px-5 tablet-m:pt-[64px] tablet-m:pb-[160px]">
      <div
        className="flex flex-col px-7 mx-[-12px] mb-[-16px] rotate-[-2deg] bg-gray-50 bg-safer-dating-banner bg-cover bg-no-repeat bg-center tablet-m:w-[1280px] tablet-m:flex-row tablet-m:justify-center tablet-m:rotate-[-2deg] tablet-m:py-[64px] tablet-m:m-0"
        style={
          !ResponsiveModel.isMobile
            ? {
                clipPath: `url(#${ARTICLE_PREVIEW_CLIPPATH_ID})`,
              }
            : undefined
        }
      >
        <PartySvg className="self-center tablet-m:self-auto rotate-[-5.3deg] mt-[-42px] tablet-m:mt-0 tablet-m:rotate-[-5.3deg] tablet-m:max-w-[580px] tablet-m:mr-12" />
        <div className="pl-5 pb-[80px] tablet-m:pl-0 tablet-m:pb-0">
          <h2 className="max-w-[277px] mb-6 text-[32px] leading-[40px] mt-[32px] rotate-[-4deg] tablet-m:rotate-[-8deg] tablet-m:max-w-[454px] tablet-m:mt-[42px] tablet-m:text-[48px] tablet-m:leading-[48px] tablet-m:tracking-[1px]  tablet-m:mb-6 font-quirk-bold">
            {title}
          </h2>
          <p className="relative ml-1 mb-5 tablet-m:ml-0 max-w-[300px] rotate-[-0.3deg] text-[16px] leading-[20px] tablet-m:text-[20px] tablet-m:leading-[24px] tablet-m:rotate-[-4.31deg] tablet-m:max-w-[460px] tablet-m:ml-4 tablet-m:mb-[44px]">
            {description}
          </p>
          <SaferDatingButton
            uri={buttonHref}
            routing={false}
            className="rotate-[-2deg] ml-12 tablet-m:ml-8"
          >
            {buttonText}
          </SaferDatingButton>
        </div>
      </div>
    </section>
  )
})
